export const state = {
	// id of selected scenario (used for db interaction and touches the route param)
	selectedLoanId: null,
	// indicates if the loan is a legacy loan or not
	isLegacyLoan: false,
	// list of users with underwriting privileges. Initialized for local testing purposes
	users: [
		{
			username: 'local',
			userId: 1
		},
		{
			username: 'test',
			userId: 2
		}
	],
	// currently selected scenario
	haloScenario: {
		id: null,
		fields: [],
		sections: [],
		categories: [],
		rules: [],
		adjustments: [],
		compensatingFactors: [],
		exceptionCategories: [],
		userId: null,
		username: null,
		userPersonas: [],
		runBetaRules: false,
		valid: null,
		creditReportFound: false
	},
	// scenario used in the scenario tool
	toolScenario: {
		id: null,
		fields: [],
		sections: [],
		categories: [],
		rules: [],
		adjustments: [],
		compensatingFactors: [],
		exceptionCategories: [],
		userId: null,
		username: null,
		userPersonas: [],
		runBetaRules: false,
		valid: null,
		creditReportFound: false
	},
	// the first scenario being compared
	compareScenario1: {
		id: null,
		fields: [],
		sections: [],
		categories: [],
		rules: [],
		adjustments: [],
		compensatingFactors: [],
		exceptionCategories: null, 
		userId: null,
		username: null,
		userIsManager: false,
		valid: null,
		created: null,
		creditReportFound: false,
	},
	// the second scenario being compared
	compareScenario2: {
		id: null,
		fields: [],
		sections: [],
		categories: [],
		rules: [],
		adjustments: [],
		compensatingFactors: [],
		exceptionCategories: null, 
		userId: null,
		username: null,
		userIsManager: false,
		valid: null,
		created: null,
		creditReportFound: false
	},
	// list of {scenarioId,timeCreated}
	compareOptions: [],
	// currently selected section (tab)
	selectedSection: {
		name: 'AUS'
	},
	// invalid sections from HALO
	haloInvalidSections: [],
	// invalid sections from scenario tool
	toolInvalidSections: [],
	// the rule selected when making an exception
	selectedRule: {
		fields: [],
		message: "",
		username: "",
		valid: true,
		exceptionLevel: 2,
		override: {
			guideline: "",
			actualValue: "",
			comment: "",
			grantedByUserId: "", 
			grantedByUsername: "",
			grantedByDate: null,
			userId: "",
			userame: "",
			created: null,
			category: "",
			type: "",
			confirmed: false,
			sendToCrse: true
		},
		ruleId: null,
		ruleVersion: null
	},
	// used to store override data when an exception is being created
	currentOverride: {
		guideline: "",
		actualValue: "",
		comment: "",
		grantedByUserId: "", 
		grantedByUsername: "",
		grantedByDate: null,
		userId: "",
		userame: "",
		created: null,
		category: "",
		type: "",
		sendToCrse: true,
		confirmed: false
	},
	// used to store comp factor data when a 'Other' comp factor is being created
	currentCompFactor: {
		fields: [],
		manager: true,
		message: "Manager required",
		name: "",
		valid: false,
		valueMessage: ""
	},
	// number of compensating factors in terms of viability for exceptions
	passingCompFactorLength: 0,
	// has the scenario run since an edit
	hasRun: false,
	// stores the previous run state of the scenario
	wasRun: false,
	// triggers the rules table animation when changed
	rulesAnimationState: false,
	// have there been any changes since the scenario was last saved
	saved: true,
	// value to store whether an alert should be displayed due to values in exceptions should be changed
	displayValueChangeMessage: false,
	// value to store whether an alert should be displayed due to too few compensating factors
	displayCompFactorMessage: false,
	// value stating whether or not the encompass plugin function for saving a scenario was successful or not
	saveSuccess: true,
	// value stating whether or not a valid credit report was found
	creditReportFound: true
};